import { render, staticRenderFns } from "./ButtonCallToAction.vue?vue&type=template&id=775672ec&scoped=true&"
import script from "./ButtonCallToAction.vue?vue&type=script&lang=js&"
export * from "./ButtonCallToAction.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCallToAction.vue?vue&type=style&index=0&id=775672ec&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775672ec",
  null
  
)

export default component.exports